import React, { useEffect, useState, useRef } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { BookOpen, Users, Briefcase, Music, ArrowRight, CheckCircle2, Calendar, Recycle, X, Loader2, GraduationCap, Award, Sparkles, Building2, Handshake, UserPlus, PartyPopper, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { saveSubmission } from '../services/databaseService';
import { sendViaWeb3Forms } from '../services/web3formsService';
type ModalType = 'ateliers' | 'festival' | 'employeur' | 'recruter' | 'partenariat' | 'recyclage' | null;
export function ActionsPage() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [formationAutre, setFormationAutre] = useState('');
  const [showFormationAutre, setShowFormationAutre] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  // Auto-open ateliers modal if URL contains #inscription
  useEffect(() => {
    if (window.location.hash === '#inscription') {
      setActiveModal('ateliers');
      // Clean the hash without page reload
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData(formRef.current!);
    const data: Record<string, any> = {};
    formData.forEach((value, key) => {
      if (data[key]) {
        // Handle multiple values (checkboxes)
        if (Array.isArray(data[key])) {
          data[key].push(value);
        } else {
          data[key] = [data[key], value];
        }
      } else {
        data[key] = value;
      }
    });
    // Map form data to submission types
    let submission: any = {
      type: ''
    };
    switch (activeModal) {
      case 'ateliers':
        submission = {
          type: 'atelier',
          nom: data.nom || '',
          prenom: data.prenom || '',
          dateNaissance: data.dateNaissance || '',
          sexe: data.sexe || '',
          situation: data.situation || '',
          niveauEtudes: data.niveauEtudes || '',
          ville: data.ville || '',
          quartier: data.quartier || '',
          telephone: data.telephone || '',
          email: data.email || '',
          formationSouhaitee: data.formationSouhaitee || '',
          formationAutre: formationAutre || '',
          source: data.source || '',
          motivations: data.motivations || ''
        };
        break;
      case 'festival':
        submission = {
          type: 'festival',
          nom: data.nom || '',
          prenom: data.prenom || '',
          telephone: data.telephone || '',
          email: data.email || '',
          profil: data.profil || '',
          participation: data.participation || '',
          message: data.message || ''
        };
        break;
      case 'employeur':
        submission = {
          type: 'employeur',
          nom: data.nom || '',
          prenom: data.prenom || '',
          typeEmployeur: data.typeEmployeur || '',
          ville: data.ville || '',
          telephone: data.telephone || '',
          email: data.email || '',
          profilsRecherches: data.profilsRecherches || '',
          attentes: data.attentes || ''
        };
        break;
      case 'recruter':
        submission = {
          type: 'recruter',
          nom: data.nom || '',
          prenom: data.prenom || '',
          telephone: data.telephone || '',
          email: data.email || '',
          ville: data.ville || '',
          quartier: data.quartier || '',
          typePersonnel: data.typePersonnel || '',
          typeContrat: data.typeContrat || '',
          dateDebut: data.dateDebut || '',
          description: data.description || ''
        };
        break;
      case 'partenariat':
        submission = {
          type: 'partenariat',
          organisation: data.organisation || '',
          typeOrganisation: data.typeOrganisation || '',
          nomContact: data.nomContact || '',
          fonction: data.fonction || '',
          telephone: data.telephone || '',
          email: data.email || '',
          typePartenariat: data.typePartenariat || '',
          proposition: data.proposition || ''
        };
        break;
      case 'recyclage':
        // Collect checked points
        const pointsFormation: string[] = [];
        document.querySelectorAll('input[name="pointsFormation"]:checked').forEach(el => {
          pointsFormation.push((el as HTMLInputElement).value);
        });
        submission = {
          type: 'recyclage',
          nomEmployeur: data.nomEmployeur || '',
          telephoneEmployeur: data.telephoneEmployeur || '',
          emailEmployeur: data.emailEmployeur || '',
          villeEmployeur: data.villeEmployeur || '',
          nomEmploye: data.nomEmploye || '',
          posteActuel: data.posteActuel || '',
          anciennete: data.anciennete || '',
          telephoneEmploye: data.telephoneEmploye || '',
          pointsFormation: pointsFormation,
          autresPoints: data.autresPoints || '',
          periodeSouhaitee: data.periodeSouhaitee || '',
          dureeSouhaitee: data.dureeSouhaitee || '',
          observations: data.observations || ''
        };
        break;
    }
    try {
      // Sauvegarder localement
      saveSubmission(submission);
      // Collecter les champs pour Web3Forms
      const fields: Record<string, string> = {};
      formData.forEach((value, key) => {
        if (typeof value === 'string') {
          fields[key] = value;
        }
      });
      if (formationAutre) {
        fields['formationAutre'] = formationAutre;
      }
      // Envoyer via Web3Forms
      const web3Result = await sendViaWeb3Forms({
        type: activeModal!,
        fields
      });
      console.log('📧 Web3Forms result:', web3Result);
      setIsSubmitting(false);
      setIsSuccess(true);
    } catch (error) {
      console.error('Error saving submission:', error);
      setIsSubmitting(false);
      setIsSuccess(true); // Montrer succès quand même (sauvegardé localement)
    }
  };
  const closeModal = () => {
    setActiveModal(null);
    setIsSuccess(false);
    setShowFormationAutre(false);
    setFormationAutre('');
  };
  const handleFormationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setShowFormationAutre(e.target.value === 'autre');
  };
  const inputClass = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all';
  const selectClass = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all bg-white';
  const labelClass = 'text-sm font-medium text-gray-700';
  const modalConfigs = {
    ateliers: {
      title: 'Inscription aux Ateliers',
      subtitle: 'Mars 2026 - Remplissez ce formulaire pour candidater',
      successMessage: 'Candidature envoyée ! Notre équipe examinera votre profil et vous contactera très prochainement.'
    },
    festival: {
      title: 'Participation au Festival',
      subtitle: 'Juin 2026 - Inscrivez-vous pour participer au Festival des Personnels de Maison',
      successMessage: "Inscription enregistrée ! Vous recevrez bientôt les détails de l'événement."
    },
    employeur: {
      title: 'Devenir Employeur Partenaire',
      subtitle: "Rejoignez notre réseau d'employeurs engagés pour un emploi digne",
      successMessage: 'Demande envoyée ! Notre équipe vous contactera pour finaliser votre adhésion.'
    },
    recruter: {
      title: 'Recruter un Personnel Formé',
      subtitle: 'Décrivez vos besoins et nous vous mettrons en relation avec des profils qualifiés',
      successMessage: 'Demande reçue ! Nous vous proposerons des profils correspondant à vos critères.'
    },
    partenariat: {
      title: 'Proposer un Partenariat',
      subtitle: "Collaborons ensemble pour l'insertion professionnelle digne",
      successMessage: 'Proposition reçue ! Notre équipe étudiera votre demande et vous recontactera.'
    },
    recyclage: {
      title: 'Recycler mon Employé',
      subtitle: 'Offrez une formation de mise à niveau à votre personnel',
      successMessage: 'Demande enregistrée ! Nous vous contacterons pour organiser la formation.'
    }
  };
  return <Layout data-id="element-209">
      <SEO {...pageSEO.actions} data-id="element-210" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-211">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-212">
          <h1 className="text-4xl font-bold mb-4" data-id="element-213">Nos Actions</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-214">
            Les actions de l'ADCC s'articulent autour de quatre piliers
            complémentaires : le développement des compétences, la valorisation
            sociale et culturelle, l'accompagnement à l'insertion
            professionnelle, et le recyclage des compétences.
          </p>
        </div>
      </div>

      {/* Four Pillars Introduction */}
      <section className="py-16 bg-white" data-id="element-215">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-217">
            {[{
            icon: BookOpen,
            title: 'Développement des Compétences',
            desc: 'Acquisition de compétences techniques'
          }, {
            icon: Users,
            title: 'Valorisation Sociale',
            desc: 'Reconnaissance et dignité des métiers de service'
          }, {
            icon: Briefcase,
            title: 'Insertion & Suivi',
            desc: 'Accompagnement vers un emploi durable'
          }, {
            icon: Recycle,
            title: 'Recyclage',
            desc: 'Reconversion et mise à jour des compétences'
          }].map((pillar, index) => <Card key={index} className="text-center border-t-4 border-t-[#1E88E5] hover:shadow-lg transition-shadow duration-300" data-id="element-218">
                <CardContent className="pt-8 pb-6" data-id="element-219">
                  <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-4" data-id="element-220">
                    <pillar.icon className="w-8 h-8 text-[#1E88E5]" data-id="element-221" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-222">
                    {pillar.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-223">{pillar.desc}</p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Festival - Juin 2026 */}
      <section className="py-20 bg-white" data-id="element-224">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
          <div className="flex flex-col lg:flex-row-reverse gap-12 items-center" data-id="element-226">
            <div className="w-full lg:w-1/2" data-id="element-227">
              <div className="relative rounded-2xl overflow-hidden shadow-xl min-h-[400px] bg-purple-100 flex items-center justify-center group" data-id="element-228">
                <img src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Festival des personnels de maison Juin 2026" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-229" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300" data-id="element-230"></div>
                <div className="absolute top-4 right-4 bg-white px-4 py-2 rounded-full shadow-md z-10 flex items-center gap-2" data-id="element-231">
                  <Calendar className="w-5 h-5 text-[#1E88E5]" data-id="element-232" />
                  <span className="font-bold text-gray-900" data-id="element-233">Juin 2026</span>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2" data-id="element-234">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-235">
                Valorisation & Networking
              </span>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-2" data-id="element-236">
                Festival des Personnels de Maison – Juin 2026
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-237">
                Un événement unique célébrant la dignité et les compétences des
                personnels de maison, combinant valorisation culturelle et
                opportunités professionnelles.
              </p>

              <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 mb-6" data-id="element-238">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-239">
                  Au programme :
                </h3>
                <div className="space-y-3" data-id="element-240">
                  {['Célébrations culturelles et témoignages inspirants', 'Espace de rencontres professionnelles', 'Présentation de profils qualifiés aux employeurs', 'Ateliers de networking et speed-meeting', "Création de passerelles vers l'emploi"].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-241">
                      <Music className="w-5 h-5 text-[#1E88E5] flex-shrink-0 mt-0.5" data-id="element-242" />
                      <span className="text-sm text-gray-700" data-id="element-243">{item}</span>
                    </div>)}
                </div>
              </div>

              <Button variant="secondary" className="gap-2" onClick={() => setActiveModal('festival')} data-id="element-244">
                <PartyPopper className="w-4 h-4" data-id="element-245" />
                Participer au festival
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Placement & Insertion Section */}
      <section className="py-20 bg-gray-50" data-id="element-246">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
          <div className="text-center mb-12" data-id="element-248">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-249">
              Notre Pilier Stratégique
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4" data-id="element-250">
              Insertion & Suivi Professionnels
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-251">
              L'ADCC met en place un dispositif d'accompagnement continu de
              personnels qui ont suivi nos ateliers, en collaboration avec des
              familles, entreprises, institutions et partenaires.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-252">
            <Card className="bg-white" data-id="element-253">
              <CardContent className="p-8" data-id="element-254">
                <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-255">
                  Ce que nous proposons
                </h3>
                <div className="space-y-4" data-id="element-256">
                  {[{
                  title: 'Identification des besoins et préparation des profils',
                  desc: 'Évaluation des compétences et matching avec les besoins'
                }, {
                  title: 'Mise en relation avec des employeurs',
                  desc: 'Réseau de familles, entreprises et structures partenaires'
                }, {
                  title: "Sensibilisation aux bonnes pratiques d'emploi",
                  desc: 'Accompagnement des employeurs au respect des droits'
                }, {
                  title: 'Suivi post-placement et médiation si nécessaire',
                  desc: 'Accompagnement continu pour garantir la durabilité'
                }].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-257">
                      <div className="flex-shrink-0 w-8 h-8 bg-blue-50 rounded-full flex items-center justify-center" data-id="element-258">
                        <span className="text-[#1E88E5] font-bold text-sm" data-id="element-259">
                          {index + 1}
                        </span>
                      </div>
                      <div data-id="element-260">
                        <h4 className="font-semibold text-gray-900 mb-1" data-id="element-261">
                          {item.title}
                        </h4>
                        <p className="text-sm text-gray-600" data-id="element-262">{item.desc}</p>
                      </div>
                    </div>)}
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-[#1E88E5] to-[#1976D2] text-white" data-id="element-263">
              <CardContent className="p-8" data-id="element-264">
                <h3 className="text-xl font-bold mb-6" data-id="element-265">Notre Objectif</h3>
                <p className="text-lg text-blue-100 mb-8" data-id="element-266">
                  Créer un cadre structuré, sécurisé et respectueux pour
                  l'emploi des personnels de maison et de services.
                </p>

                <div className="space-y-4" data-id="element-267">
                  {[{
                  title: 'Dignité',
                  desc: 'Respect des droits et de la personne'
                }, {
                  title: 'Transparence',
                  desc: "Clarté sur les conditions d'emploi"
                }, {
                  title: 'Durabilité',
                  desc: 'Insertion professionnelle à long terme'
                }].map((item, index) => <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg p-4" data-id="element-268">
                      <div className="flex items-center gap-3 mb-2" data-id="element-269">
                        <CheckCircle2 className="w-6 h-6" data-id="element-270" />
                        <h4 className="font-bold" data-id="element-271">{item.title}</h4>
                      </div>
                      <p className="text-sm text-blue-100" data-id="element-272">{item.desc}</p>
                    </div>)}
                </div>

                <div className="mt-8 space-y-3" data-id="element-273">
                  <Button variant="ghost" className="w-full bg-white text-[#1E88E5] hover:bg-gray-100" onClick={() => setActiveModal('employeur')} data-id="element-274">
                    <Building2 className="w-4 h-4 mr-2" data-id="element-275" />
                    Devenir employeur partenaire
                  </Button>
                  <Button variant="ghost" className="w-full bg-white/20 text-white hover:bg-white/30 border border-white/30" onClick={() => setActiveModal('recyclage')} data-id="element-276">
                    <RefreshCw className="w-4 h-4 mr-2" data-id="element-277" />
                    Recycler mon employé
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 text-center" data-id="element-278">
            <p className="text-2xl font-bold text-gray-900 mb-4" data-id="element-279">
              "Notre engagement : transformer les compétences en opportunités
              d'emploi."
            </p>
            <p className="text-gray-600" data-id="element-280">
              L'insertion professionnelle constitue un indicateur clé de
              réussite de nos programmes.
            </p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-white" data-id="element-281">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-282">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-283">
            Rejoignez notre réseau de partenaires
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-284">
            Que vous soyez une famille, une entreprise ou une institution,
            devenez partenaire de l'ADCC pour favoriser l'insertion
            professionnelle digne.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center flex-wrap" data-id="element-285">
            <Button size="lg" className="gap-2" onClick={() => setActiveModal('recruter')} data-id="element-286">
              <UserPlus className="w-5 h-5" data-id="element-287" />
              Recruter un personnel compétent
            </Button>
            <Button variant="secondary" size="lg" className="gap-2" onClick={() => setActiveModal('partenariat')} data-id="element-288">
              <Handshake className="w-5 h-5" data-id="element-289" />
              Proposer un partenariat
            </Button>
            <Button variant="secondary" size="lg" className="gap-2" onClick={() => setActiveModal('recyclage')} data-id="element-290">
              <RefreshCw className="w-5 h-5" data-id="element-291" />
              Recycler mon employé
            </Button>
          </div>
        </div>
      </section>

      {/* Modal */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm overflow-y-auto" data-id="element-292">
          <div className="bg-white rounded-2xl w-full max-w-3xl shadow-2xl my-8 relative max-h-[90vh] overflow-y-auto" data-id="element-293">
            <button onClick={closeModal} className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 text-gray-500 transition-colors z-10" data-id="element-294">
              <X className="w-6 h-6" data-id="element-295" />
            </button>

            <div className="p-8" data-id="element-296">
              <div className="text-center mb-8" data-id="element-297">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-298">
                  {modalConfigs[activeModal].title}
                </h2>
                <p className="text-gray-600 mt-2" data-id="element-299">
                  {modalConfigs[activeModal].subtitle}
                </p>
              </div>

              {isSuccess ? <div className="text-center py-12" data-id="element-300">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-301">
                    <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-302" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-303">
                    Demande envoyée !
                  </h3>
                  <p className="text-gray-600 mb-8" data-id="element-304">
                    {modalConfigs[activeModal].successMessage}
                  </p>
                  <Button onClick={closeModal} data-id="element-305">Fermer</Button>
                </div> : <form ref={formRef} onSubmit={handleSubmit} className="space-y-6" data-id="element-306">
                  {/* Formulaire Ateliers */}
                  {activeModal === 'ateliers' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-307">
                      <div className="space-y-2" data-id="element-308">
                        <label className={labelClass} data-id="element-309">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom de famille" data-id="element-310" />
                      </div>
                      <div className="space-y-2" data-id="element-311">
                        <label className={labelClass} data-id="element-312">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-313" />
                      </div>
                      <div className="space-y-2" data-id="element-314">
                        <label className={labelClass} data-id="element-315">
                          Date de naissance *
                        </label>
                        <input name="dateNaissance" type="date" required className={inputClass} data-id="element-316" />
                      </div>
                      <div className="space-y-2" data-id="element-317">
                        <label className={labelClass} data-id="element-318">Sexe *</label>
                        <select name="sexe" required className={selectClass} data-id="element-319">
                          <option value="" data-id="element-320">Sélectionner...</option>
                          <option value="F" data-id="element-321">Femme</option>
                          <option value="H" data-id="element-322">Homme</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-323">
                        <label className={labelClass} data-id="element-324">
                          Situation professionnelle *
                        </label>
                        <select name="situation" required className={selectClass} data-id="element-325">
                          <option value="" data-id="element-326">Sélectionner...</option>
                          <option value="emploi" data-id="element-327">En emploi</option>
                          <option value="sans_emploi" data-id="element-328">Sans emploi</option>
                          <option value="etudiant" data-id="element-329">Étudiant(e)</option>
                          <option value="autre" data-id="element-330">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-331">
                        <label className={labelClass} data-id="element-332">Niveau d'études</label>
                        <select name="niveauEtudes" className={selectClass} data-id="element-333">
                          <option value="" data-id="element-334">Sélectionner...</option>
                          <option value="sans" data-id="element-335">Sans diplôme</option>
                          <option value="cep" data-id="element-336">CEP</option>
                          <option value="bepc" data-id="element-337">BEPC</option>
                          <option value="bac" data-id="element-338">BAC</option>
                          <option value="licence" data-id="element-339">Licence</option>
                          <option value="master" data-id="element-340">Master</option>
                          <option value="autre" data-id="element-341">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-342">
                        <label className={labelClass} data-id="element-343">Ville *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-344" />
                      </div>
                      <div className="space-y-2" data-id="element-345">
                        <label className={labelClass} data-id="element-346">Quartier *</label>
                        <input name="quartier" type="text" required className={inputClass} placeholder="Ex: Haie Vive" data-id="element-347" />
                      </div>
                      <div className="space-y-2" data-id="element-348">
                        <label className={labelClass} data-id="element-349">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-350" />
                      </div>
                      <div className="space-y-2" data-id="element-351">
                        <label className={labelClass} data-id="element-352">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-353" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-354">
                        <label className={labelClass} data-id="element-355">
                          Formation souhaitée
                        </label>
                        <select name="formationSouhaitee" className={selectClass} onChange={handleFormationChange} data-id="element-356">
                          <option value="" data-id="element-357">Sélectionner...</option>
                          <option value="employe_maison" data-id="element-358">
                            Employé(e) de maison
                          </option>
                          <option value="agent_entretien" data-id="element-359">
                            Agent(e) d'entretien en entreprise
                          </option>
                          <option value="femme_chambre" data-id="element-360">
                            Femme de chambre / Valet d'hôtel
                          </option>
                          <option value="serveur" data-id="element-361">
                            Serveur(se) en restauration
                          </option>
                          <option value="garde_enfant" data-id="element-362">Garde d'enfant</option>
                        </select>
                      </div>
                      {showFormationAutre && <div className="space-y-2 md:col-span-2" data-id="element-363">
                          <label className={labelClass} data-id="element-364">
                            Précisez la formation souhaitée *
                          </label>
                          <input type="text" required className={inputClass} placeholder="Décrivez la formation que vous souhaitez suivre" value={formationAutre} onChange={e => setFormationAutre(e.target.value)} data-id="element-365" />
                        </div>}
                      <div className="space-y-2 md:col-span-2" data-id="element-366">
                        <label className={labelClass} data-id="element-367">
                          Comment avez-vous connu l'ADCC ?
                        </label>
                        <select name="source" className={selectClass} data-id="element-368">
                          <option value="" data-id="element-369">Sélectionner...</option>
                          <option value="reseaux" data-id="element-370">Réseaux sociaux</option>
                          <option value="bouche" data-id="element-371">Bouche à oreille</option>
                          <option value="radio" data-id="element-372">Radio</option>
                          <option value="affiche" data-id="element-373">Affiche / Flyer</option>
                          <option value="autre" data-id="element-374">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-375">
                        <label className={labelClass} data-id="element-376">
                          Vos motivations (facultatif)
                        </label>
                        <textarea name="motivations" rows={3} className={inputClass + ' resize-none'} placeholder="Pourquoi souhaitez-vous suivre cette formation ?" data-id="element-377"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Festival */}
                  {activeModal === 'festival' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-378">
                      <div className="space-y-2" data-id="element-379">
                        <label className={labelClass} data-id="element-380">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom" data-id="element-381" />
                      </div>
                      <div className="space-y-2" data-id="element-382">
                        <label className={labelClass} data-id="element-383">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-384" />
                      </div>
                      <div className="space-y-2" data-id="element-385">
                        <label className={labelClass} data-id="element-386">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-387" />
                      </div>
                      <div className="space-y-2" data-id="element-388">
                        <label className={labelClass} data-id="element-389">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-390" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-391">
                        <label className={labelClass} data-id="element-392">Vous êtes *</label>
                        <select name="profil" required className={selectClass} data-id="element-393">
                          <option value="" data-id="element-394">Sélectionner...</option>
                          <option value="personnel" data-id="element-395">Personnel de maison</option>
                          <option value="employeur" data-id="element-396">Employeur</option>
                          <option value="partenaire" data-id="element-397">
                            Partenaire / Institution
                          </option>
                          <option value="media" data-id="element-398">Média / Presse</option>
                          <option value="autre" data-id="element-399">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-400">
                        <label className={labelClass} data-id="element-401">
                          Participation souhaitée
                        </label>
                        <select name="participation" className={selectClass} data-id="element-402">
                          <option value="" data-id="element-403">Sélectionner...</option>
                          <option value="visiteur" data-id="element-404">Visiteur</option>
                          <option value="exposant" data-id="element-405">Exposant / Stand</option>
                          <option value="temoin" data-id="element-406">Témoignage</option>
                          <option value="recruteur" data-id="element-407">Espace recrutement</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-408">
                        <label className={labelClass} data-id="element-409">
                          Message (facultatif)
                        </label>
                        <textarea name="message" rows={3} className={inputClass + ' resize-none'} placeholder="Informations complémentaires..." data-id="element-410"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Employeur Partenaire */}
                  {activeModal === 'employeur' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-411">
                      <div className="space-y-2" data-id="element-412">
                        <label className={labelClass} data-id="element-413">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom" data-id="element-414" />
                      </div>
                      <div className="space-y-2" data-id="element-415">
                        <label className={labelClass} data-id="element-416">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-417" />
                      </div>
                      <div className="space-y-2" data-id="element-418">
                        <label className={labelClass} data-id="element-419">Type d'employeur *</label>
                        <select name="typeEmployeur" required className={selectClass} data-id="element-420">
                          <option value="" data-id="element-421">Sélectionner...</option>
                          <option value="famille" data-id="element-422">Famille / Particulier</option>
                          <option value="entreprise" data-id="element-423">Entreprise</option>
                          <option value="institution" data-id="element-424">Institution / ONG</option>
                          <option value="hotel" data-id="element-425">Hôtel / Restaurant</option>
                          <option value="autre" data-id="element-426">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-427">
                        <label className={labelClass} data-id="element-428">Ville *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-429" />
                      </div>
                      <div className="space-y-2" data-id="element-430">
                        <label className={labelClass} data-id="element-431">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-432" />
                      </div>
                      <div className="space-y-2" data-id="element-433">
                        <label className={labelClass} data-id="element-434">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-435" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-436">
                        <label className={labelClass} data-id="element-437">Profils recherchés</label>
                        <select name="profilsRecherches" className={selectClass} data-id="element-438">
                          <option value="" data-id="element-439">Sélectionner...</option>
                          <option value="menage" data-id="element-440">Personnel d'entretien</option>
                          <option value="cuisine" data-id="element-441">Cuisinier(ère)</option>
                          <option value="garde" data-id="element-442">Garde d'enfants</option>
                          <option value="gardien" data-id="element-443">
                            Gardien / Agent de sécurité
                          </option>
                          <option value="chauffeur" data-id="element-444">Chauffeur</option>
                          <option value="polyvalent" data-id="element-445">Polyvalent</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-446">
                        <label className={labelClass} data-id="element-447">
                          Vos attentes (facultatif)
                        </label>
                        <textarea name="attentes" rows={3} className={inputClass + ' resize-none'} placeholder="Décrivez vos besoins et attentes..." data-id="element-448"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Recruter */}
                  {activeModal === 'recruter' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-449">
                      <div className="space-y-2" data-id="element-450">
                        <label className={labelClass} data-id="element-451">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom" data-id="element-452" />
                      </div>
                      <div className="space-y-2" data-id="element-453">
                        <label className={labelClass} data-id="element-454">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-455" />
                      </div>
                      <div className="space-y-2" data-id="element-456">
                        <label className={labelClass} data-id="element-457">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-458" />
                      </div>
                      <div className="space-y-2" data-id="element-459">
                        <label className={labelClass} data-id="element-460">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-461" />
                      </div>
                      <div className="space-y-2" data-id="element-462">
                        <label className={labelClass} data-id="element-463">Ville *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-464" />
                      </div>
                      <div className="space-y-2" data-id="element-465">
                        <label className={labelClass} data-id="element-466">Quartier</label>
                        <input name="quartier" type="text" className={inputClass} placeholder="Ex: Haie Vive" data-id="element-467" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-468">
                        <label className={labelClass} data-id="element-469">
                          Type de personnel recherché *
                        </label>
                        <select name="typePersonnel" required className={selectClass} data-id="element-470">
                          <option value="" data-id="element-471">Sélectionner...</option>
                          <option value="menage" data-id="element-472">
                            Personnel d'entretien ménager
                          </option>
                          <option value="cuisine" data-id="element-473">Cuisinier(ère)</option>
                          <option value="garde" data-id="element-474">
                            Garde d'enfants / Nounou
                          </option>
                          <option value="gardien" data-id="element-475">Gardien</option>
                          <option value="chauffeur" data-id="element-476">Chauffeur</option>
                          <option value="maintenance" data-id="element-477">
                            Agent de maintenance
                          </option>
                          <option value="polyvalent" data-id="element-478">
                            Personnel polyvalent
                          </option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-479">
                        <label className={labelClass} data-id="element-480">
                          Type de contrat souhaité
                        </label>
                        <select name="typeContrat" className={selectClass} data-id="element-481">
                          <option value="" data-id="element-482">Sélectionner...</option>
                          <option value="temps_plein" data-id="element-483">
                            Temps plein (logé ou non)
                          </option>
                          <option value="temps_partiel" data-id="element-484">Temps partiel</option>
                          <option value="ponctuel" data-id="element-485">
                            Intervention ponctuelle
                          </option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-486">
                        <label className={labelClass} data-id="element-487">
                          Date de début souhaitée
                        </label>
                        <input name="dateDebut" type="date" className={inputClass} data-id="element-488" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-489">
                        <label className={labelClass} data-id="element-490">
                          Description du poste et attentes *
                        </label>
                        <textarea name="description" rows={4} required className={inputClass + ' resize-none'} placeholder="Décrivez les tâches, horaires, conditions..." data-id="element-491"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Partenariat */}
                  {activeModal === 'partenariat' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-492">
                      <div className="space-y-2" data-id="element-493">
                        <label className={labelClass} data-id="element-494">
                          Nom de l'organisation *
                        </label>
                        <input name="organisation" type="text" required className={inputClass} placeholder="Nom de votre structure" data-id="element-495" />
                      </div>
                      <div className="space-y-2" data-id="element-496">
                        <label className={labelClass} data-id="element-497">
                          Type d'organisation *
                        </label>
                        <select name="typeOrganisation" required className={selectClass} data-id="element-498">
                          <option value="" data-id="element-499">Sélectionner...</option>
                          <option value="entreprise" data-id="element-500">Entreprise privée</option>
                          <option value="ong" data-id="element-501">ONG / Association</option>
                          <option value="institution" data-id="element-502">
                            Institution publique
                          </option>
                          <option value="fondation" data-id="element-503">Fondation</option>
                          <option value="media" data-id="element-504">Média</option>
                          <option value="autre" data-id="element-505">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-506">
                        <label className={labelClass} data-id="element-507">Nom du contact *</label>
                        <input name="nomContact" type="text" required className={inputClass} placeholder="Votre nom complet" data-id="element-508" />
                      </div>
                      <div className="space-y-2" data-id="element-509">
                        <label className={labelClass} data-id="element-510">Fonction *</label>
                        <input name="fonction" type="text" required className={inputClass} placeholder="Votre poste" data-id="element-511" />
                      </div>
                      <div className="space-y-2" data-id="element-512">
                        <label className={labelClass} data-id="element-513">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-514" />
                      </div>
                      <div className="space-y-2" data-id="element-515">
                        <label className={labelClass} data-id="element-516">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-517" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-518">
                        <label className={labelClass} data-id="element-519">
                          Type de partenariat envisagé
                        </label>
                        <select name="typePartenariat" className={selectClass} data-id="element-520">
                          <option value="" data-id="element-521">Sélectionner...</option>
                          <option value="financier" data-id="element-522">Soutien financier</option>
                          <option value="technique" data-id="element-523">Appui technique</option>
                          <option value="formation" data-id="element-524">
                            Co-animation de formations
                          </option>
                          <option value="emploi" data-id="element-525">
                            Offres d'emploi / Recrutement
                          </option>
                          <option value="communication" data-id="element-526">
                            Visibilité / Communication
                          </option>
                          <option value="autre" data-id="element-527">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-528">
                        <label className={labelClass} data-id="element-529">
                          Description de votre proposition *
                        </label>
                        <textarea name="proposition" rows={4} required className={inputClass + ' resize-none'} placeholder="Décrivez votre proposition de partenariat..." data-id="element-530"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Recyclage */}
                  {activeModal === 'recyclage' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-531">
                      <div className="space-y-2 md:col-span-2 bg-teal-50 p-4 rounded-lg border border-teal-200" data-id="element-532">
                        <h4 className="font-semibold text-teal-800 flex items-center gap-2" data-id="element-533">
                          <RefreshCw className="w-5 h-5" data-id="element-534" />
                          Informations sur l'employeur
                        </h4>
                      </div>
                      <div className="space-y-2" data-id="element-535">
                        <label className={labelClass} data-id="element-536">
                          Votre nom complet *
                        </label>
                        <input name="nomEmployeur" type="text" required className={inputClass} placeholder="Nom de l'employeur" data-id="element-537" />
                      </div>
                      <div className="space-y-2" data-id="element-538">
                        <label className={labelClass} data-id="element-539">Téléphone *</label>
                        <input name="telephoneEmployeur" type="tel" required className={inputClass} placeholder="+229..." data-id="element-540" />
                      </div>
                      <div className="space-y-2" data-id="element-541">
                        <label className={labelClass} data-id="element-542">Email *</label>
                        <input name="emailEmployeur" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-543" />
                      </div>
                      <div className="space-y-2" data-id="element-544">
                        <label className={labelClass} data-id="element-545">Ville *</label>
                        <input name="villeEmployeur" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-546" />
                      </div>

                      <div className="space-y-2 md:col-span-2 bg-blue-50 p-4 rounded-lg border border-blue-200 mt-4" data-id="element-547">
                        <h4 className="font-semibold text-blue-800 flex items-center gap-2" data-id="element-548">
                          <Users className="w-5 h-5" data-id="element-549" />
                          Informations sur l'employé à recycler
                        </h4>
                      </div>
                      <div className="space-y-2" data-id="element-550">
                        <label className={labelClass} data-id="element-551">Nom de l'employé *</label>
                        <input name="nomEmploye" type="text" required className={inputClass} placeholder="Nom complet de l'employé" data-id="element-552" />
                      </div>
                      <div className="space-y-2" data-id="element-553">
                        <label className={labelClass} data-id="element-554">Poste actuel *</label>
                        <select name="posteActuel" required className={selectClass} data-id="element-555">
                          <option value="" data-id="element-556">Sélectionner...</option>
                          <option value="menage" data-id="element-557">Personnel d'entretien</option>
                          <option value="cuisine" data-id="element-558">Cuisinier(ère)</option>
                          <option value="garde" data-id="element-559">Garde d'enfants</option>
                          <option value="gardien" data-id="element-560">Gardien</option>
                          <option value="chauffeur" data-id="element-561">Chauffeur</option>
                          <option value="polyvalent" data-id="element-562">Polyvalent</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-563">
                        <label className={labelClass} data-id="element-564">
                          Ancienneté chez vous
                        </label>
                        <select name="anciennete" className={selectClass} data-id="element-565">
                          <option value="" data-id="element-566">Sélectionner...</option>
                          <option value="moins_1" data-id="element-567">Moins d'1 an</option>
                          <option value="1_3" data-id="element-568">1 à 3 ans</option>
                          <option value="3_5" data-id="element-569">3 à 5 ans</option>
                          <option value="plus_5" data-id="element-570">Plus de 5 ans</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-571">
                        <label className={labelClass} data-id="element-572">
                          Téléphone de l'employé
                        </label>
                        <input name="telephoneEmploye" type="tel" className={inputClass} placeholder="+229..." data-id="element-573" />
                      </div>

                      <div className="space-y-2 md:col-span-2 bg-amber-50 p-4 rounded-lg border border-amber-200 mt-4" data-id="element-574">
                        <h4 className="font-semibold text-amber-800 flex items-center gap-2" data-id="element-575">
                          <GraduationCap className="w-5 h-5" data-id="element-576" />
                          Formation de recyclage souhaitée
                        </h4>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-577">
                        <label className={labelClass} data-id="element-578">
                          Points de formation souhaités *
                        </label>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2" data-id="element-579">
                          {["Techniques d'entretien avancées", 'Hygiène et sécurité', 'Communication et savoir-être', 'Gestion du temps et organisation', 'Cuisine et nutrition', "Garde d'enfants et pédagogie", 'Maintenance et petites réparations', 'Premiers secours'].map((item, i) => <label key={i} className="flex items-center gap-2 p-2 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer" data-id="element-580">
                              <input name="pointsFormation" type="checkbox" value={item} className="w-4 h-4 text-[#1E88E5] rounded" data-id="element-581" />
                              <span className="text-sm text-gray-700" data-id="element-582">
                                {item}
                              </span>
                            </label>)}
                        </div>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-583">
                        <label className={labelClass} data-id="element-584">
                          Autres points de formation (précisez)
                        </label>
                        <input name="autresPoints" type="text" className={inputClass} placeholder="Autres compétences à développer..." data-id="element-585" />
                      </div>
                      <div className="space-y-2" data-id="element-586">
                        <label className={labelClass} data-id="element-587">
                          Période souhaitée *
                        </label>
                        <select name="periodeSouhaitee" required className={selectClass} data-id="element-588">
                          <option value="" data-id="element-589">Sélectionner...</option>
                          <option value="urgent" data-id="element-590">Dès que possible</option>
                          <option value="1mois" data-id="element-591">Dans le mois</option>
                          <option value="3mois" data-id="element-592">
                            Dans les 3 prochains mois
                          </option>
                          <option value="flexible" data-id="element-593">Flexible</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-594">
                        <label className={labelClass} data-id="element-595">
                          Durée de formation souhaitée
                        </label>
                        <select name="dureeSouhaitee" className={selectClass} data-id="element-596">
                          <option value="" data-id="element-597">Sélectionner...</option>
                          <option value="1jour" data-id="element-598">1 journée</option>
                          <option value="2_3jours" data-id="element-599">2-3 jours</option>
                          <option value="1semaine" data-id="element-600">1 semaine</option>
                          <option value="flexible" data-id="element-601">À définir ensemble</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-602">
                        <label className={labelClass} data-id="element-603">
                          Observations complémentaires
                        </label>
                        <textarea name="observations" rows={3} className={inputClass + ' resize-none'} placeholder="Points particuliers à signaler, difficultés observées..." data-id="element-604"></textarea>
                      </div>
                    </div>}

                  <div className="pt-4 border-t border-gray-100 flex justify-end gap-4" data-id="element-605">
                    <Button type="button" variant="ghost" onClick={closeModal} data-id="element-606">
                      Annuler
                    </Button>
                    <Button type="submit" disabled={isSubmitting} className="min-w-[200px]" data-id="element-607">
                      {isSubmitting ? <>
                          <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-608" />
                          Envoi en cours...
                        </> : 'Soumettre'}
                    </Button>
                  </div>
                </form>}
            </div>
          </div>
        </div>}
    </Layout>;
}